import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from '../../utils';
import moment from 'moment';

export const Receipt = ({ transaction }) => {

    if (transaction.payment_method?.payment_processor === 'valitorpay') {
        return (
            <div className="receipt row">
                <div className="col-12 mb-3">
                    <h3>{transaction.data.receipt.cardInformation.cardScheme == "M" ? "Mastercard" : "Visa"} {transaction.data.receipt.cardInformation.cardUsage}</h3>
                </div>
                <div className="col-6 mb-4">{gettext('Date')} {moment(transaction.created_at).format('DD.MM.yyyy')}</div>
                <div className="col-6 mb-4 text-end">{gettext('Time')} { moment(transaction.created_at).format('HH:mm:ss')}</div>
                <div className="col-12 mt-3 mb-5">{transaction.data.receipt.maskedCardNumber}</div>
                <div className="col-12 text-center mt-3">
                    <h3>{gettext('Sale')}</h3>
                </div>
                <div className="col-12 text-center mb-5 mt-4">
                    <h3>{transaction.currency} {formatMoney(transaction.amount)}</h3>
                </div>
                <div className="col-6">{gettext('Authorization nr.')}<br />{transaction.data.receipt.authorizationCode}</div>
                <div className="col-6 text-end">{gettext('Transaction nr.')}<br />{transaction.data.receipt.transactionID}</div>
                <div className="col-12 text-center">{transaction.data.receipt.acquirerReferenceNumber}</div>
            </div>
        );
    }

};
